import React from 'react';
import {
    ButtonBase,
    Typography,
} from '@material-ui/core';
import classNames from 'classnames';
import QCTooltip from '@pluto/qc-tooltip';
import {FrameRate} from '@accurate-player/accurate-player-core';

import {OnClickEvent} from '@pluto/@types';
import WaveformContainer from '../Waveform/WaveformContainer';
import {getButtonIcon} from '../AudioTracksUtils';

import './AudioChannel.scss';

export interface AudioChannelProps {
    onlyMonoAudioAvailable: boolean;
    label: string;
    enabled: boolean;
    waveformUrl: string;
    frameRate: FrameRate;
    onToggle: () => void;
    onRowClick: OnClickEvent;
}

export default function AudioChannel(props: AudioChannelProps) {
    const {
        onlyMonoAudioAvailable,
        label,
        enabled,
        frameRate,
        waveformUrl,
        onToggle,
        onRowClick,
    } = props;
    
    const buttonIcon = getButtonIcon(enabled);
    
    return (
        <ap-timeline-row
            class="channel-row"
            onClick={onRowClick}
        >
            <span
                slot="header"
                className="row-header"
            >
                <Typography
                    variant="body2"
                    color="textSecondary"
                    className={classNames('row-header__label', {
                        disabled: !enabled,
                    })}
                >
                    {label}
                </Typography>
                {!onlyMonoAudioAvailable && (
                    <QCTooltip
                        title="Toggle Audio Channel on/off"
                        arrow
                    >
                        <ButtonBase
                            onClick={onToggle}
                            aria-label="Toggle Audio Channel on/off"
                            className="channel-mute-button"
                        >
                            {buttonIcon}
                        </ButtonBase>
                    </QCTooltip>
                )}
            </span>
            <WaveformContainer
                url={waveformUrl}
                enabled={enabled}
                frameRate={frameRate}
            />
        </ap-timeline-row>
    );
}
